import CheckCircleFilled from "@ant-design/icons/CheckCircleFilled";
import Title from "common/Typography/Title";
import styled, { useTheme } from "styled-components";
import React from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface FreeOrFreeTrialTagProps {
  hasFreeTrial: boolean;
  isFree: boolean;
}

const FreeOrFreeTrialTag = ({
  hasFreeTrial,
  isFree,
}: FreeOrFreeTrialTagProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.MARKETPLACE);
  const appTheme = useTheme();
  let iconColor = appTheme.colors.lightGreen;
  let title = t("tags.free");

  if (!isFree) {
    title = hasFreeTrial ? t("tags.free_trial") : t("tags.no_free_trial");
    if (!hasFreeTrial) iconColor = appTheme.colors.lightGrey;
  }

  return (
    <FreeTrialWrapper>
      <CheckCircleFilled
        style={{
          color: iconColor,
          fontSize: 13,
          marginRight: 5,
          position: "relative",
          top: -1,
        }}
      />
      <Title type="secondary" level={5}>
        {title}
      </Title>
    </FreeTrialWrapper>
  );
};

export default FreeOrFreeTrialTag;

const FreeTrialWrapper = styled.div`
  display: flex;
  align-items: center;
`;
